import styled, { ITheme } from '../../../theme'

export const Title = styled.strong<ITitle>`
  font-weight: 600;
  border-bottom: 1px solid
    ${(props: ITheme) => props.theme.colors.palette.greyTwo};
  color: ${({ theme }: ITheme) => theme.colors.form.label};
  padding-bottom: ${({ withButton, size }) =>
    size ? (withButton ? 2 * size : 10 * size) : 10}px;

  padding-right: ${props =>
    props.withButton
      ? props.size
        ? 10 * props.size
        : 10
      : props.size
      ? 20 * props.size
      : 20}px;
  user-select: none;
`

export default Title

export interface ITitle {
  withButton?: boolean
  size?: number
}
